import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../../redux/store";
import { fetchAuth } from "../../../../redux/profile/authAndReg/asyncActions";
import { authAndRegSelector } from "../../../../redux/profile/authAndReg/selectors";
import { clearErrorMessage } from "../../../../redux/profile/authAndReg/slice";

import { PhoneInput, PasswordInput, Button } from "../../../../components";
import { cleanPhone } from "../../../../utils";

import { ValidMessages } from "../../../../resources/locale";

import styles from "./AuthForm.module.scss";

import { SubmitValueType, AuthFormPropsType } from "./types";

export const AuthForm: React.FC<AuthFormPropsType> = (props) => {
  const { handleChangePass } = props;
  const { isLoading, errorMessage } = useSelector(authAndRegSelector);
  const dispatch = useAppDispatch();

  const initialValues = {
    phone: "",
    password: "",
  };

  const validationSchema = Yup.object({
    phone: Yup.string()
      .min(18, ValidMessages.inputs.phone.NOT_FULL)
      .required(ValidMessages.inputs.phone.REQUIRED),
    password: Yup.string()
      .required(ValidMessages.inputs.password.REQUIRED)
      .min(6, ValidMessages.inputs.password.NOT_FULL),
  });

  const handleSubmit = (values: SubmitValueType) => {
    const data = {
      phone: cleanPhone(values.phone),
      password: values.password,
    };
    dispatch(fetchAuth(data));
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <PhoneInput name="phone" lable="Телефон" placeholder="+7 (___) ___-__-__" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="phone"
              />
            </div>
            <div className={styles.formSection}>
              <PasswordInput name="password" lable="Пароль" placeholder="Пароль" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="password"
              />
              {errorMessage 
                ? (
                  <div className={styles.errorMessage}>
                    {errorMessage.includes('Not allowed')
                      ? "Сервер временно недоступен"
                      : errorMessage.includes('Invalid credentials')
                        ? "Неверный номер телефона или пароль"
                        : errorMessage}
                  </div>
                ) : null
              }
            </div>
            <div className={styles.forgotPassword}>
              <a href="#" className={styles.link} onClick={handleChangePass}>
                Забыли пароль?
              </a>
            </div>
            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting || isLoading}
            >
              {isLoading ? "Авторизация..." : "Войти"}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
